const COOKIE_NAME = 'slp_hash';

export function retrieveLanderCookie(shouldDeleteCookie = false): string {
    const slpHashCookie = document.cookie.split(';').find((cookie) => cookie.trim().startsWith(`${COOKIE_NAME}=`));

    if (!slpHashCookie) {
        return '';
    }

    const slpHash = slpHashCookie.split('=')[1];

    if (shouldDeleteCookie) {
        deleteLanderCookie();
    }
    return slpHash || '';
}

function deleteLanderCookie() {
    const domainParts = window.location.hostname.split('.');
    const mainDomain = domainParts.slice(-2).join('.');
    document.cookie = `${COOKIE_NAME}=; domain=${mainDomain}; path=/; max-age=0;`;
}
